var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 10.8398C5.625 5.84844 9.86849 1.875 15 1.875C20.1315 1.875 24.375 5.84844 24.375 10.8398C24.375 13.6538 22.8536 17.1352 21.1869 20.1444C19.4953 23.1987 17.5472 25.9504 16.5024 27.3613C16.33 27.597 16.1046 27.7888 15.8444 27.9213C15.5828 28.0544 15.2935 28.1238 15 28.1238C14.7065 28.1238 14.4172 28.0544 14.1556 27.9213C13.8953 27.7888 13.6699 27.5969 13.4975 27.3613C12.4528 25.9498 10.5047 23.1971 8.81304 20.1424C7.14649 17.133 5.625 13.6518 5.625 10.8398ZM15 3.75C10.8151 3.75 7.5 6.9707 7.5 10.8398C7.5 13.1256 8.79101 16.2323 10.4533 19.2341C12.0861 22.1825 13.9773 24.8575 15 26.2396C16.0227 24.8581 17.9139 22.1841 19.5467 19.236C21.2089 16.2348 22.5 13.1277 22.5 10.8398C22.5 6.9707 19.1849 3.75 15 3.75Z",
    fill: "#434289"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.375C13.9645 9.375 13.125 10.2145 13.125 11.25C13.125 12.2855 13.9645 13.125 15 13.125C16.0355 13.125 16.875 12.2855 16.875 11.25C16.875 10.2145 16.0355 9.375 15 9.375ZM11.25 11.25C11.25 9.17893 12.9289 7.5 15 7.5C17.0711 7.5 18.75 9.17893 18.75 11.25C18.75 13.3211 17.0711 15 15 15C12.9289 15 11.25 13.3211 11.25 11.25Z",
    fill: "#434289"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.75202041aa2b48d449dcde9d85ed09cd.svg";
export { ForwardRef as ReactComponent };